import { HttpErrorResponse } from "@angular/common/http";

export interface MapSearchResult {
    name: string;
    highlightedName?: string;
    type: "ZONE" | "PIN";
    latitude: number;
    longitude: number;
    boundingBox: {
        minX: number;
        minY: number;
        maxX: number;
        maxY: number;
    };
}

export enum MapSearchErrorTypes {
    CannotGetSearchResults = "CannotGetSearchResults",
}

export interface MapSearchError<T> {
    error?: HttpErrorResponse;
    type: T;
}
